(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-radio-card]')];
    const buttons = [...root.querySelectorAll('[data-category-filter]')];
    const sort = root.querySelector('[data-radio-sort]');
    const count = root.querySelector('[data-radio-count]');
    const groups = [...root.querySelectorAll('[data-radio-group]')];
    const originalOrder = new Map(cards.map((card, index) => [card, index]));
    let category = 'all';

    function apply(updateURL = true) {
      let visible = 0;
      cards.forEach(card => {
        card.hidden = category !== 'all' && !card.dataset.category.split(' ').includes(category);
        if (!card.hidden) visible++;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.categoryFilter === category)));
      groups.forEach(group => {
        const grid = group.querySelector('[data-radio-grid]');
        const items = [...grid.children];
        items.sort((a, b) => {
          if (sort.value === 'name') return a.dataset.title.localeCompare(b.dataset.title);
          if (sort.value.startsWith('price-')) {
            // Quote-only products have no comparable price; keep them after priced items.
            if (a.dataset.quote !== b.dataset.quote) return a.dataset.quote === 'true' ? 1 : -1;
            const delta = Number(a.dataset.price) - Number(b.dataset.price);
            return (sort.value === 'price-desc' ? -delta : delta) || originalOrder.get(a) - originalOrder.get(b);
          }
          return originalOrder.get(a) - originalOrder.get(b);
        });
        items.forEach(card => grid.appendChild(card));
        group.hidden = !items.some(card => !card.hidden);
      });
      count.textContent = `${visible} ${visible === 1 ? 'product' : 'products'}`;
      root.querySelector('[data-radio-empty]').hidden = visible !== 0;
      root.querySelector('[data-radio-reset]').hidden = category === 'all';
      if (updateURL) {
        const url = new URL(location.href);
        category === 'all' ? url.searchParams.delete('type') : url.searchParams.set('type', category);
        sort.value === 'featured' ? url.searchParams.delete('radio_sort') : url.searchParams.set('radio_sort', sort.value);
        history.replaceState(history.state, '', url);
      }
    }
    function readURL() {
      const params = new URL(location.href).searchParams;
      const requested = params.get('type');
      category = buttons.some(button => button.dataset.categoryFilter === requested) ? requested : 'all';
      const requestedSort = params.get('radio_sort');
      sort.value = [...sort.options].some(option => option.value === requestedSort) ? requestedSort : 'featured';
      apply(false);
    }
    buttons.forEach(button => button.addEventListener('click', () => { category = button.dataset.categoryFilter; apply(); }));
    sort.addEventListener('change', () => apply());
    root.querySelector('[data-radio-reset]').addEventListener('click', () => { category = 'all'; apply(); });
    root.querySelector('[data-radio-brand]').addEventListener('change', event => {
      const url = new URL(event.target.value, location.origin);
      const current = new URL(location.href);
      ['view', 'preview_theme_id', 'type', 'radio_sort'].forEach(key => {
        if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      });
      location.assign(url);
    });
    const compare = root.querySelector('.radio-compare');
    root.querySelector('.radio-header__compare').addEventListener('click', () => { compare.open = true; });
    root.querySelectorAll('[data-radio-clear-family]').forEach(link => {
      const url = new URL(link.href);
      const current = new URL(location.href);
      ['view', 'preview_theme_id'].forEach(key => {
        if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      });
      link.href = url.href;
    });
    window.addEventListener('popstate', readURL);
    root.querySelector('[data-radio-tools]').hidden = false;
    readURL();
  }
  document.querySelectorAll('[data-radio-collection]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-radio-collection]').forEach(init));
})();
